import { render, staticRenderFns } from "./TemplateFourEn.vue?vue&type=template&id=245edfca&"
import script from "./TemplateFourEn.vue?vue&type=script&lang=js&"
export * from "./TemplateFourEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports